// Maps a lesson link pasted into a trainer message (the public URLs from the
// lessons sheet / Zendesk macros, e.g. learning.petcademy.org/lesson/...) to the
// in-hub lesson route. The Messages page uses this to open lesson links in the
// SAME tab as the in-hub lesson instead of a new-tab public page, so the lesson
// feels like part of the Hub and Back returns to /hub/messages.
//
// Returns null for anything that isn't a catalog lesson on a host we serve —
// those links keep the thread's default behavior. The loadLesson gate also
// excludes retired guides (e.g. /guide/rehoming/*), whose public URLs redirect
// off-catalog and must not be rewritten into a hub 404.
import { loadLesson } from '../../Lesson';
import lessonSlugFromUrl from '../../Lesson/lessonUrl';
import { HUB_ORIGIN, LESSONS_HOST } from '../../PublicLesson/hubOrigin';

const HUB_HOST = new URL(HUB_ORIGIN).host;

export default function hubLessonPath(href: string, currentHost: string): string | null {
  // Only hosts this app serves the Hub/lessons from: the lessons subdomain, the
  // canonical Hub origin, and whatever host is serving right now (staging,
  // branch deploys, local dev).
  const slug = lessonSlugFromUrl(href, [LESSONS_HOST, HUB_HOST, currentHost]);
  if (!slug || !loadLesson(slug)) return null;
  return `/hub/lessons-and-guides/${slug}`;
}
